/*
 * @Author: Roman
 * @Date: 2022-12-13 11:16:39
 * @LastEditors: romanyuen@qpp.com yuan719...
 * @LastEditTime: 2022-12-15 10:16:08
 * @FilePath: \qpmn-site\src\app\modules\user\rest\anonymous-rest.config.ts
 * @Description: 
 */
import { IRestfulConfigMap } from "@core/data-access/restful";
import { envConfig } from "@env/env-config";


let AnonymousRestServiceConfig: IRestfulConfigMap = {
    anonymousRestService: {
        appPath: envConfig.appPath("base"),
        isAuth: false,
        actions: {
            login: {
                method: "get",
                path: "anonymousUser/:anonymousUserId/token/",
                testPath: "anonymousUser/:anonymousUserId/token/",
                paramDefaults: {
                    "anonymousUserId": "@anonymousUserId"
                }
            }
        }
    }
}


export { AnonymousRestServiceConfig };